const ApplyCouponConfig = [{ span: 8, height: "24px", classes: "marginTop-56 " }]

export default ApplyCouponConfig
